import { useRef } from 'react'
import { toast } from 'react-toastify'
import { useFormContext } from 'react-hook-form'
import { Typography } from '@mui/material'
import { IconCheck, IconPaperclip, IconX } from '@tabler/icons-react'
import { AttachButton, FileBadge, FileList } from './styles'

type AttachedFilesProps = {
  disabled?: boolean
  loading?: boolean
}

export const AttachedFiles: React.FC<AttachedFilesProps> = ({ disabled = false, loading = false }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { watch, setValue } = useFormContext()

  const attachedFile: File = watch('file')

  const handleFileSelect = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setValue('file', file)
      toast.success('Arquivo anexado com sucesso')
    }

    if (fileInputRef.current) {
      fileInputRef.current.value = ''
    }
  }

  const handleRemoveFile = () => {
    setValue('file', null)
    toast.info('Arquivo removido')
  }

  const isDisabled = disabled || loading

  return (
    <>
      {attachedFile && (
        <FileList>
          <FileBadge key={attachedFile.name}>
            <IconCheck size={16} color='#00A86B' />
            <Typography 
              variant='body2' 
              sx={{ 
                fontSize: '0.75rem',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                color: '#777'
              }}
            >
              {attachedFile.name}
            </Typography>
            <button
              onClick={handleRemoveFile}
              style={{
                display: 'flex',
                alignItems: 'center',
                background: 'transparent',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                minWidth: 'auto'
              }}
            >
              <IconX size={14} color='#EF4444' />
            </button>
          </FileBadge>
        </FileList>
      )}

      <AttachButton
        onClick={handleFileSelect}
        style={{
          cursor: isDisabled ? 'not-allowed' : 'pointer',
          opacity: isDisabled ? 0.5 : 1,
          pointerEvents: isDisabled ? 'none' : 'auto'
        }}
      >
        <IconPaperclip size={18} />
        <Typography variant='body2' sx={{ fontSize: '0.875rem', color: 'inherit' }}>
          Anexar arquivo
        </Typography>
      </AttachButton>

      <input
        ref={fileInputRef}
        type='file'
        style={{ display: 'none' }}
        onChange={handleFileChange}
        disabled={isDisabled || !!attachedFile}
      />
    </>
  )
}
